module.exports = __webpack_public_path__ + "img/presentation_site_lobbyx.17dcb922.png";